export default __webpack_public_path__ + "static/media/location_preview_eerie_estates.f8596354.svg";